import React, { Component } from "react";
import server from "../Components/Server";
import Calendar from "../images/icons/calendar.png";
import M from "materialize-css";
import ErrorIcon from "@material-ui/icons/Error";

import Calculation from "./Calculation";
import Progress from "./Progress";
import { connect } from "react-redux";
import headerImg from "../images/header.jpeg";
import { fetchLoaderRun, setMessage, setNewDate } from "../actions";

class Calculator extends Component {
	state = {
		pickedDate: null,
		formatDate: null,
		message: null,
		pendingRequest: null,
		// success: null,
		// unsuccess: null,
		calcMode: false
	};
	controller = new AbortController();
	datepicker = null;
	loadRecaptcha = null;
	grecaptcha = null;
	timeout = null;

	clickHandler = (e) => {
		// open datepicker
		e.preventDefault();
		this.datepicker[0].open();
	};

	clearMessage = () => {
		this.setState({ pendingRequest: null });
		this.timeout && clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.props.setMessage(null);
			//this.setState({ message: null });
		}, 4000);
	};

	handleSubmit = (e) => {
		e.preventDefault();
		const data = new URLSearchParams(new FormData(e.target));
		data.append(
			"date",
			new Date(
				Date.UTC(
					this.state.pickedDate && this.state.pickedDate.getFullYear(),
					this.state.pickedDate && this.state.pickedDate.getMonth(),
					this.state.pickedDate && this.state.pickedDate.getDate()
				)
			)
		);
		data.append("datef", this.state.formatDate);
		if (!Date.prototype.isPrototypeOf(this.state.pickedDate)) {
			this.props.setMessage("error", this.props.langBase.need_date);

			// this.setState({
			//   message: this.props.store.getState().langBase.no_date
			// });
			this.clearMessage();
			return;
		}

		document.getElementById("submitButton").setAttribute("disabled", true);

		this.setState({ pendingRequest: true, message: null });
		this.props.fetchLoaderRun(true);
		//this.controller = new AbortController();

		fetch(server.checkDate, {
			body: data,
			method: "POST",
			mode: "cors",
			credentials: "include",
			signal: this.controller.signal
		})
			.then((response) => response.json())
			.then((data) => {
				document.getElementById("submitButton").removeAttribute("disabled");
				this.clearMessage();
				if (data.responseCode) {
					//this.setState({ message: data.responseDesc });
					this.props.setMessage("error", this.props.langBase[data.responseDesc]);
					this.props.fetchLoaderRun(false);
					return;
				} else if (data.responseDesc === "AUTH:OK") {
					this.setState({ calcMode: true });
					// data slubu
					this.props.setNewDate(this.state.formatDate, true);
				}
				this.props.fetchLoaderRun(false);
			})
			.catch((err) => {
				const button = document.getElementById("submitButton");
				button && button.removeAttribute("disabled");
				if (err.code !== 20) {
					this.setState({
						message: this.props.langBase.no_internet
					});
					this.clearMessage();
				}
			});
	};

	componentDidMount() {
		this.controller = new AbortController();
		// define datepicker and init
		const elems = document.querySelectorAll(".datepicker");
		this.datepicker = M.Datepicker.init(elems, {
			i18n: this.props.langBase.i18n,
			firstDay: 1,
			minDate: new Date(Date.now()),
			format: "dd mmmm yyyy",
			autoClose: true,
			defaultDate: new Date(Date.now()),
			onSelect: (pickedDate) => {
				const formatDate = `${pickedDate.getDate()} ${this.props.langBase.i18n.months[
					pickedDate.getMonth()
				]} ${pickedDate.getFullYear()}`;
				this.setState({
					pickedDate: pickedDate,
					formatDate
				});
			},
			onClose: () => {
				if (window.grecaptcha) {
					window.grecaptcha.reset();
				}
			}
		});
		try {
			window.grecaptcha.render(document.getElementById("recaptcha"));
		} catch (error) {
			this.loadRecaptcha = setTimeout(() => {
				window.grecaptcha.render(document.getElementById("recaptcha"));
			}, 1000);
		}
		// if (window.grecaptcha) {

		// } else {
		// 	this.loadRecaptcha = setTimeout(() => {
		// 		window.grecaptcha.render(document.getElementById("recaptcha"));
		// 	}, 1000);
		// 	//this.setState({ loadRecaptcha });
		// }
	}

	disableInput = () => {
		document.addEventListener("keypress", this.preventDefault);
	};

	preventDefault = (e) => {
		e.preventDefault();
	};

	enableInput = () => {
		document.removeEventListener("keypress", this.preventDefault);
	};

	componentWillUnmount() {
		this.props.fetchLoaderRun(false);
		this.controller.abort();
		clearTimeout(this.timeout);
		clearTimeout(this.loadRecaptcha);
		document.removeEventListener("keypress", this.preventDefault);
	}

	render() {
		const { langBase, messageText, fetching, message } = this.props;
		return (
			<div className="calculator">
				<div
					className="calc-header"
					style={{
						backgroundImage: `linear-gradient(to right bottom, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.2)), url(${headerImg})`,
						backgroundSize: "cover"
					}}>
					<p>{this.state.calcMode ? `${langBase.pickedDate} ${this.state.formatDate}` : "Wedding day"}</p>
					<button
						onClick={this.props.close}
						className="close"
						style={{
							position: "absolute",
							right: 0,
							top: 0
						}}>
						&times;
					</button>
				</div>
				{
					<div
						className={message ? "infoMessage visible" : "infoMessage"}
						style={{
							borderColor: messageText.typeMessage === "error" ? "#b90202" : "black",
							color: messageText.typeMessage === "error" ? "#b90202" : "black"
						}}>
						{messageText.typeMessage === "error" ? <ErrorIcon /> : ""}
						<span>{messageText.text}</span>
					</div>
				}
				<div className="progress" style={{ height: "5px" }}>
					{fetching && <Progress />}
				</div>

				{!this.state.calcMode && (
					<div className="calc-body">
						<form id="calc-form" onSubmit={this.handleSubmit}>
							<div className="input-field styled">
								<input
									id="datePicker"
									type="text"
									name="datepicker"
									className="datepicker"
									placeholder={langBase.enter_date}
									autoComplete="off"
									onFocus={this.disableInput}
									onBlur={this.enableInput}
								/>
								<button onClick={this.clickHandler}>
									<img src={Calendar} alt="" />
								</button>
							</div>
							<br />
							<div className="label">{langBase.antibot}</div>
							<div
								id="recaptcha"
								className="g-recaptcha"
								data-sitekey="6LevBP0SAAAAAKlGPeuz_lAhBKAtESW1P1DdGYEC"
							/>

							<div className="message" style={{ color: "red" }}>
								{this.state.message}
							</div>
							<button id="submitButton" type="submit">
								{langBase.check}
							</button>
						</form>
					</div>
				)}
				{this.state.calcMode && (
					<div className="calc-body">
						<Calculation close={this.props.close} />
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	langBase: state.langBase,
	messageText: { ...state.messageText },
	fetching: state.fetching,
	message: state.message
});

const mapDispatchToProps = {
	fetchLoaderRun,
	setMessage,
	setNewDate
};

export default connect(mapStateToProps, mapDispatchToProps)(Calculator);
